/** A dependency on the Yes answer to an earlier Yes/No workflow step. */
export const YES_ANSWER_DEP_PREFIX = '__answer_yes__';

export const yesAnswerDependency = (stepKey: string): string => `${YES_ANSWER_DEP_PREFIX}${stepKey}`;

export const yesAnswerStepKey = (dependency: string): string | null =>
  dependency.startsWith(YES_ANSWER_DEP_PREFIX)
    ? dependency.slice(YES_ANSWER_DEP_PREFIX.length) || null
    : null;

export const yesAnswerForStep = (
  dependency: string,
  steps: Array<{ key: string; fieldKey?: string }>,
  workflowCase: { stepData?: Record<string, any> } | null | undefined
): boolean => {
  const key = yesAnswerStepKey(dependency);
  if (!key) return false;
  const question = steps.find((step) => step.key === key);
  if (!question) return false;
  const fieldKey = String(question.fieldKey || question.key).trim();
  return workflowCase?.stepData?.[key]?.[fieldKey] === true;
};
